import React from 'react';
import Typography from '@src/new-components/Typography';
import { CardGuide, HeaderCard } from './index.style';

const CardGuideItem = ({ icon, title, description, width = '100%' }) => (
  <CardGuide width={width}>
    <HeaderCard>
      {icon}
      <Typography component="p" color="#1C1C1E" variant="body-16-medium">
        {title}
      </Typography>
    </HeaderCard>
    <Typography
      component="p"
      color="#1C1C1EA3"
      variant="body-14-regular"
      height={32}
    >
      {description}
    </Typography>
  </CardGuide>
);

export default CardGuideItem;
